export async function loadCoursesData() {
  const response = await fetch('/courses-data', {
    headers: {
      Accept: 'application/json'
    }
  });

  if (!response.ok) {
    throw new Error(`Failed to load courses data: ${response.status}`);
  }

  return response.json();
}
